module.exports = __webpack_public_path__ + "static/media/model-shogun-sport-09.a0d671fd.webp";